import React from "react";

import styles from "./ContactInfo.scss";
import confirmModal from "../../../services/confirmModal";
import { getIconUrl } from "../../../services/asset";

const section = {
  needHelp: "need-help",
  workingHours: "working-hours",
  email: "email",
};

function ContactInfo({ id, title, value, clickable = false }) {
  const handleNeedHelp = (e) => {
    e.preventDefault();

    confirmModal.show({
      title: "Nazovi korisničku podršku",
      iconType: "NaN",
      wrapClassName: "needHelp",
      width: 520,
      footer: null,
      children: (
        <p className={styles.text}>
          Naša korisnička podrška dostupna je svakog radnog dana od 08:00 do 16:00 za sva pitanja vezana uz korištenje stranice, pomoć pri postavljanju oglasa ili rješavanje tehničkih poteškoća.
          <span className={styles.hardBoldedText}>
            Za informacije o oglasu, kontaktirajte prodavatelja izravno putem poruka iz oglasa ili pozivom na broj naveden u oglasu.
          </span>
          Ako i dalje trebate pomoć korisničke podrške, nazovite nas na: <br /><br />
          <a href="tel:0916089171" style={{ textDecoration: "underline" }}>
            091 608 9171
          </a>
        </p>
      ),
    });
  };

  return (
    <div className={styles.contactText}>
      {id === section.needHelp ? (
        <button
          onClick={(e) => handleNeedHelp(e)}
          className={styles.helpButton}
        >
          <img
            alt={"Nazovi"}
            src={getIconUrl("phone-black.svg")}
          />
          <span className={styles.text}>
            {"Nazovi podršku"}
          </span>
        </button>
      ) : (
        <React.Fragment>
          <span className={`${styles.title} 
            ${id === section.workingHours ? styles.workingHours : ""}`}>{title}</span>
          <span className={`${styles.value} ${clickable ? styles.clickable : ""}`}>{value}</span>
        </React.Fragment>
      )}

    </div>
  );
}

export default ContactInfo;



// WEBPACK FOOTER //
// ./src/components/Footer/ContactInfo/ContactInfo.tsx